<template>
  <!-- <button class="shopBtn__access" @click.stop="showAccess">アクセス</button>
  <button :class="{shopBtn__favorite: true, active: isFavorite }" v-if="show_favorite" @click.stop="toggleFavorite">{{ isFavorite ? '登録解除' : '登録する' }}</button> -->
  <div class="shop-item mb-16" @click.prevent="selectShop">
    {{shop_data.name}}
    <div class="d-flex align-items-center gap">
      <favorite-icon
        v-if="show_favorite && shop_follows.includes(shop_data.id)"
        :isActive="shop_follows.includes(shop_data.id)"
        :toggleFavorite="() => {}"
      />
      <img src="/assets/images/icon/icon-right-grey.svg" height="14" alt="" style="margin-left: 8px;" />
    </div>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import store from "../store";
import FavoriteIcon from "./FavoriteIcon.vue";

export default Vue.extend({
  name: 'ShopButton',
  components: {
    FavoriteIcon
  },
  store,
  props: ["shop_data", "show_favorite", "shop_follows", "active", "is_change", "onselect", "onaccess", "onfavorite", "selected", "noarrow"],
  computed: {
    noArrow() {
      return this.noarrow === true ? true : false;
    },
    isFavorite() {
      return this.show_favorite ? this.shop_follows.indexOf(this.shop_data.id) != -1 : false
    }
  },
  methods: {
    selectShop() {
      if (this.onselect){
        this.onselect(this.shop_data)
      }
    },
    showAccess() {
      if (this.onaccess) {
        this.onaccess(this.shop_data)
      }
    },
    toggleFavorite() {
      if (this.onfavorite) {
        this.onfavorite(this.shop_data)
      }
    }
  }
})
</script>